import React from 'react';

import ConnectedSensorComparison from './ConnectedSensorComparison';

const ScreenWidthCheck = () => <ConnectedSensorComparison />;

export default ScreenWidthCheck;
